module.exports = __webpack_public_path__ + "img/ambientacion3-zoom.555088fa.jpg";